export function groupBy(array, key) {
    var groupedObject = {};
    for (var _i = 0, array_1 = array; _i < array_1.length; _i++) {
        var item = array_1[_i];
        var value = item[key];
        var currentGroup = groupedObject[value];
        if (currentGroup === undefined) {
            // initialize group array, with current item
            groupedObject[value] = [item];
        }
        else {
            // group already exists, add item
            currentGroup.push(item);
        }
    }
    return groupedObject;
}
/**
 * type-guard function to check at run-time if all the elements inside
 * from the array are strings
 * @param array
 * @returns - boolean, true if the array is string array
 */
export function isStringArray(array) {
    return (Array.isArray(array) &&
        array.every(function (element) { return typeof element === 'string'; }));
}
